const formData = {
  add: [
    {
      refer_key: "name",
      return_key: "holder",
      input_type: "select",
      input_value: "",
      input_label: "Holder",
      input_valid: false,
      input_check_valid: true,
      input_regex: "^\\d+$",
      input_placeholder: "",
      input_hidden: false,
      elementConfig: {
        options: [],
        option_value_key: "id",
        option_label_key: "name"
      }
    },
    {
      refer_key: "band_name",
      return_key: "band_id",
      input_type: "select",
      input_value: "",
      input_label: "Band",
      input_valid: false,
      input_check_valid: true,
      input_regex: "^\\d+$",
      input_placeholder: "",
      input_hidden: true,
      elementConfig: {
        options: [],
        option_value_key: "id",
        option_label_key: "band_name"
      }
    },
    {
      refer_key: "competency_name",
      return_key: "fitment_id",
      input_type: "select",
      input_value: "",
      input_label: "Prefill Attributes",
      input_valid: false,
      input_check_valid: false,
      input_regex: "^\\d+$",
      input_placeholder: "",
      input_hidden: true,
      elementConfig: {
        options: [],
        option_value_key: "id",
        option_label_key: "fitment_name"
      }
    },
    {
      refer_key: "fitment_name",
      return_key: "fitment_name",
      input_type: "text",
      input_value: "",
      input_label: "Fitment Name",
      input_valid: false,
      input_check_valid: true,
      input_regex: "^[ A-z0-9]*((- |s)*[ A-z0-9])$",
      input_placeholder: "enter role fitment name ...",
      input_hidden: true,
      elementConfig: {
        options: [],
        option_value_key: "",
        option_label_key: ""
      }
    }
  ],
  edit: [
    {
      refer_key: "name",
      return_key: "holder",
      input_type: "select",
      input_value: "",
      input_label: "Holder",
      input_valid: false,
      input_check_valid: true,
      input_regex: "^\\d+$",
      input_placeholder: "",
      input_hidden: false,
      elementConfig: {
        options: [],
        option_value_key: "id",
        option_label_key: "name"
      }
    },
    {
      refer_key: "band_name",
      return_key: "band_id",
      input_type: "select",
      input_value: "",
      input_label: "Band",
      input_valid: false,
      input_check_valid: true,
      input_regex: "^\\d+$",
      input_placeholder: "",
      input_hidden: false,
      elementConfig: {
        options: [],
        option_value_key: "id",
        option_label_key: "band_name"
      }
    },
    {
      refer_key: "competency_name",
      return_key: "fitment_id",
      input_type: "select",
      input_value: "",
      input_label: "Prefill Attributes",
      input_valid: false,
      input_check_valid: false,
      input_regex: "^\\d+$",
      input_placeholder: "",
      input_hidden: true,
      elementConfig: {
        options: [],
        option_value_key: "id",
        option_label_key: "fitment_name"
      }
    },
    {
      refer_key: "fitment_name",
      return_key: "fitment_name",
      input_type: "text",
      input_value: "",
      input_label: "Fitment Name",
      input_valid: false,
      input_check_valid: true,
      input_regex: "^[ A-z0-9]*((- |s)*[ A-z0-9])$",
      input_placeholder: "enter role fitment name ...",
      input_hidden: true,
      elementConfig: {
        options: [],
        option_value_key: "",
        option_label_key: ""
      }
    }
  ]
};

export default formData;



// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/DetailLinks/RoleFitmentReport/formData.jsx